import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@gsa/afp-component-library';
import { useFormContext, Controller } from 'react-hook-form';

const SolicitationDetail = ({ control }) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div className="solicitation-details-container grid-col-6 margin-y-6">
      <div className="title-m-bold">Solicitation details</div>
      <Controller
        name="solicitationTitle"
        control={control}
        render={({ field }) => (
          <TextInput
            {...field}
            data-testid="solicitation-title"
            className="title-input"
            label="Solicitation title"
            aria-label="Solicitation title"
            maxLength="255"
            errorMessage={errors.solicitationTitle?.message}
            required
          />
        )}
      />
      <Controller
        name="solicitationDescription"
        control={control}
        render={({ field }) => (
          <TextInput
            {...field}
            type="textarea"
            data-testid="solicitation-description"
            aria-label="Solicitation description"
            label="Description"
            maxLength="1000"
            hint="1000 characters allowed"
            errorMessage={errors.solicitationDescription?.message}
          />
        )}
      />
      <Controller
        name="solicitationPosting"
        control={control}
        render={({ field }) => (
          <TextInput
            {...field}
            label="Solicitation posting"
            aria-label="Solicitation posting"
            data-testid="solicitation-posting"
            help="Enter the SAM posting URL"
            errorMessage={errors.solicitationPosting?.message}
          />
        )}
      />
    </div>
  );
};

SolicitationDetail.propTypes = {
  control: PropTypes.object.isRequired,
};

export default SolicitationDetail;
